import React, {useState, useEffect, useCallback} from "react";
import {Row, Col} from "reactstrap";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import SafeView from "../../../components/safeView/SafeView";
import Button from "../../../components/Button";
import {useCleanupOnUnload} from "../../../hooks/useCleanupOnUnload";
import {
  storeCreateTemplateData,
  storeCreateNonTestData,
  setNonTestFormVisibility,
  storeCreateTestData,
  setTestFormVisibility,
  storeNonTestTemplate,
  storeTestTemplateList,
  storeTestSensors,
  createTemplate,
  requestEachTemplates,
} from "../../../redux/Actions/reports.actions";
import {
  getTestFormVisiability,
  getNonTestFormVisiability,
  getCreateTemplateData,
  getNonTestTemplateList,
  getTestTemplateList,
} from "../../../redux/Selectors/reports.selectors";
import AddTemplateForm from "./addTemplateForm";
import NonTestForm from "./nonTestForm";
import TestForm from "./testForm";
import TestTemplatesList from "./testTemplatesList";

const CreateTemplate = () => {
  const [count, setCount] = useState(0);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {templateId} = useParams();
  const isTestFormVisible = useSelector(getTestFormVisiability);
  const isNonTestFormVisible = useSelector(getNonTestFormVisiability);
  const nonTestTemplateList = useSelector(getNonTestTemplateList);
  const testTemplateList = useSelector(getTestTemplateList);
  const createTemplateData = useSelector(getCreateTemplateData);
  const {name = "", description = "", appliance = {}} = createTemplateData;

  useEffect(() => {
    if (templateId) {
      dispatch(requestEachTemplates(templateId));
    }
  }, [dispatch, templateId]);

  useEffect(() => {
    if (templateId) {
      if (count >= 2) {
        dispatch(storeTestTemplateList([]));
      }
    } else {
      dispatch(storeTestTemplateList([]));
    }
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setCount((prevCount) => prevCount + 1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appliance.value]);

  const clearData = useCallback(() => {
    dispatch(storeCreateTemplateData({}));
    dispatch(storeCreateNonTestData({}));
    dispatch(setNonTestFormVisibility(false));
    dispatch(storeCreateTestData({}));
    dispatch(setTestFormVisibility(false));
    dispatch(storeNonTestTemplate([]));
    dispatch(storeTestTemplateList([]));
    dispatch(storeTestSensors([]));
  }, [dispatch]);

  useCleanupOnUnload(clearData);

  const handleCancel = () => {
    clearData();
    navigate("/app/reports");
  };

  const handleCreate = () => {
    const callback = () => {
      clearData();
      handleCancel();
    };
    if (name && appliance.value) {
      const payload = {
        ...createTemplateData,
        name,
        inventory: appliance.value,
        description,
        results: testTemplateList.map((template) => template.value),
        manual_results: nonTestTemplateList.map((template) => template.value),
      };
      dispatch(createTemplate(payload, callback));
    } else {
      toast.error("Please check required fields");
    }
  };

  return (
    <SafeView>
      <Row style={{marginTop: "1rem", marginBottom: "1rem"}}>
        <Col lg={6}>
          <div style={{marginBottom: "1rem"}}>
            <AddTemplateForm />
          </div>
          <div style={{marginBottom: "1rem"}}>
            <TestTemplatesList />
          </div>
        </Col>
        <Col lg={6}>
          {isNonTestFormVisible && (
            <div style={{marginBottom: "1rem"}}>
              <NonTestForm />
            </div>
          )}
          {isTestFormVisible && (
            <div style={{marginBottom: "1rem"}}>
              <TestForm />
            </div>
          )}
          <div className="d-flex justify-content-end">
            <Button withRadius type={"info"} onClick={handleCancel} data-cy="cancel-btn">
              CANCEL
            </Button>
            <Button withRadius onClick={handleCreate} data-cy="submit-btn">
              SAVE
            </Button>
          </div>
        </Col>
      </Row>
    </SafeView>
  );
};

export default CreateTemplate;
